/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Suggest_TitleInputs */

const en_us2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a feature`)
};

const pt_br2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma função`)
};

const es_419_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir una función`)
};

const pt_pt2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma funcionalidade`)
};

const fr_fr2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggérer une fonction`)
};

const de_de2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion vorschlagen`)
};

const it_it2_community_suggest_title = /** @type {(inputs: Community_Suggest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerisci una funzione`)
};

/**
* | output |
* | --- |
* | "Suggest a feature" |
*
* @param {Community_Suggest_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_suggest_title = /** @type {((inputs?: Community_Suggest_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Suggest_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_suggest_title(inputs)
	if (locale === "es-419") return es_419_community_suggest_title(inputs)
	if (locale === "pt-PT") return pt_pt2_community_suggest_title(inputs)
	if (locale === "fr-FR") return fr_fr2_community_suggest_title(inputs)
	if (locale === "de-DE") return de_de2_community_suggest_title(inputs)
	if (locale === "it-IT") return it_it2_community_suggest_title(inputs)
	return en_us2_community_suggest_title(inputs)
});
export { community_suggest_title as "community.suggest_title" }